<template>
              <svg
            class="logo"
            width="32"
            height="31"
            viewBox="0 0 32 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M30.7437 14.1587L24.303 2.86464C23.8397 2.0211 22.9129 1.45874 21.9399 1.45874H9.10494C8.1319 1.45874 7.20518 1.97424 6.74183 2.86464L0.347517 14.1587C-0.115839 15.0023 -0.115839 16.0333 0.347517 16.9237L6.78816 28.2178C7.25152 29.0613 8.17823 29.6237 9.15128 29.6237H21.9862C22.9593 29.6237 23.886 29.1082 24.3493 28.2178L30.7437 16.9237C31.207 16.0333 31.207 15.0023 30.7437 14.1587ZM27.1295 16.5956L22.2179 25.2185C21.8472 25.8746 21.1522 26.2964 20.4108 26.2964H10.634C9.89265 26.2964 9.19761 25.8746 8.82693 25.2185L3.96169 16.5956C3.59101 15.9396 3.59101 15.1429 3.96169 14.4868L8.82693 5.86391C9.19761 5.20782 9.89265 4.78605 10.634 4.78605H20.4108C21.1522 4.78605 21.8472 5.20782 22.2179 5.86391L27.1295 14.4868C27.5002 15.1429 27.5002 15.9396 27.1295 16.5956Z"
              fill="#0DA6A6"
            />
            <path
              d="M13.6731 14.965L14.8144 16.2854L10.5876 20.5713L9.44634 19.2509L13.6731 14.965Z"
              fill="#FF0031"
            />
            <path
              d="M17.8042 18.4643L16.5421 19.6801L13.7644 16.2934L15.0264 15.0776L17.8042 18.4643Z"
              fill="#FF0031"
            />
            <path
              d="M17.597 20.3134L16.5639 19.1501L21.6631 13.8407L22.6962 15.004L17.597 20.3134Z"
              fill="#FF0031"
            />
            <path
              d="M15.8514 15.6984C15.7775 16.607 15.0376 17.2871 14.1988 17.2173C13.3601 17.1475 12.7401 16.3543 12.814 15.4457C12.888 14.537 13.6279 13.857 14.4666 13.9268C15.3054 13.9966 15.9254 14.7898 15.8514 15.6984Z"
              fill="#FF0031"
            />
            <path
              d="M11.0907 20.4186C11.0168 21.3273 10.2769 22.0073 9.43814 21.9375C8.59939 21.8677 7.97939 21.0745 8.05335 20.1659C8.1273 19.2573 8.8672 18.5772 9.70596 18.647C10.5447 18.7168 11.1647 19.51 11.0907 20.4186Z"
              fill="#FF0031"
            />
            <path
              d="M18.9466 19.4159C18.8727 20.3246 18.1328 21.0046 17.294 20.9348C16.4552 20.865 15.8352 20.0718 15.9092 19.1632C15.9832 18.2546 16.7231 17.5745 17.5618 17.6443C18.4006 17.7141 19.0206 18.5073 18.9466 19.4159Z"
              fill="#FF0031"
            />
            <path
              d="M24.1356 14.0464C24.0617 14.9551 23.3218 15.6351 22.483 15.5653C21.6443 15.4955 21.0243 14.7023 21.0982 13.7937C21.1722 12.8851 21.9121 12.2051 22.7508 12.2748C23.5896 12.3446 24.2096 13.1378 24.1356 14.0464Z"
              fill="#FF0031"
            />
            <path
              d="M17.8946 12.7497C17.9658 12.9116 18.1928 12.9126 18.2653 12.7512L19.0016 11.1118C19.022 11.0664 19.058 11.03 19.103 11.0095L20.7009 10.2801C20.8627 10.2063 20.8596 9.97294 20.696 9.90345L19.0473 9.20331C19.0231 9.19303 19.0037 9.17368 18.9933 9.1493L18.2621 7.43534C18.1919 7.27091 17.9618 7.26964 17.8899 7.43328L17.1753 9.05884C17.155 9.10517 17.1184 9.14225 17.0726 9.16294L15.4455 9.89852C15.2852 9.971 15.2852 10.2011 15.4455 10.2736L17.0726 11.0092C17.1184 11.0299 17.155 11.0669 17.1753 11.1133L17.8946 12.7497Z"
              fill="#FF0031"
            />
            <path
              d="M9.9747 14.965C10.0132 15.1206 10.2319 15.1206 10.2704 14.965L10.6083 13.5983C10.622 13.5431 10.6646 13.5 10.7192 13.4862L12.0709 13.1445C12.2248 13.1056 12.2248 12.8844 12.0709 12.8455L10.7192 12.5038C10.6646 12.49 10.622 12.4469 10.6083 12.3917L10.2704 11.025C10.2319 10.8694 10.0132 10.8694 9.9747 11.025L9.63677 12.3917C9.62312 12.4469 9.58049 12.49 9.52589 12.5038L8.17415 12.8455C8.02025 12.8844 8.02025 13.1056 8.17415 13.1445L9.52589 13.4862C9.58049 13.5 9.62312 13.5431 9.63677 13.5983L9.9747 14.965Z"
              fill="#FF0031"
            />
          </svg>    
</template>